import { toast } from 'react-toastify';

// ---------------------------------------------------------------------------
// Feedback pós-fato do núcleo de escrita de Movements (handoff 0093) —
// compartilhado pelas telas de criação, edição e detalhe. Local do módulo até
// o wrapper global de feedback (FC4) ser liberado.
// ---------------------------------------------------------------------------

// `stock_warnings` das respostas de create/update/delete: saldos finais
// reais que ficaram negativos. Aviso persistente (o operador fecha) — o
// registro já aconteceu, isto é informação, não erro.
export function notifyStockWarnings(stockWarnings) {
   if (!Array.isArray(stockWarnings) || !stockWarnings.length) return;

   const lines = stockWarnings
      .map(
         (w) =>
            `${w.prod_sku ?? w.prod_id} — ${w.prod_name ?? 'produto'}: saldo ${
               w.resulting_qtd
            }`
      )
      .join(' · ');

   toast.warn(
      `Produto${stockWarnings.length > 1 ? 's' : ''} com saldo negativo após o registro: ${lines}`,
      { autoClose: false }
   );
}

// `snapshot_backfill` da resposta do PUT: edição retroativa reprocessa os
// snapshots históricos em background.
export function notifySnapshotBackfill(snapshotBackfill) {
   if (!snapshotBackfill) return;

   const dates = snapshotBackfill.dates ?? [];

   if (snapshotBackfill.enqueued === false) {
      toast.warn(
         'Saldo atualizado, mas o histórico de snapshot ficará defasado até reprocessamento manual.',
         { autoClose: false }
      );
      return;
   }

   if (dates.length) {
      toast.info(
         `Movimento retroativo: snapshots de ${dates.length} dia${
            dates.length > 1 ? 's' : ''
         } estão sendo reprocessados em background.`
      );
   }
}
